// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap__8ukl8","popupImg":"index_popupImg__cCnHp","closeBtn":"index_closeBtn__RVg7D","closeIcon":"index_closeIcon__XUApk"};